import { TextField, TextFieldProps } from "@mui/material";
import { IGWidget, addClass } from "../GWidget";
import { IFormFieldProps, useValidator } from "../form/Validators";

export interface IGTextFieldProps extends IGWidget, IFormFieldProps<string>, Omit<TextFieldProps,"value"> {
    value?:string;
    onEnter?:(val:string) => void
}

export default function GTextField(props:IGTextFieldProps) {
    const {onChange,helperText,floatLabel,controlName,onEnter,...textProps} = props
    const {value, setValue, hint, control, hasError} = useValidator<string>(props)
    
    const _onChange = (e:any) => {
        control?.setDirty(true)
        setValue(e.target.value) 
        props.onChange?.(e)
    }
    const onKeyDown = (e:any) => {
        if (e.key=="Enter") onEnter?.(value||"")
    }

    return <TextField className={addClass("", props)} onChange={_onChange} onKeyDown={onKeyDown}
        label={floatLabel} helperText={props.helperText||hint} error={hasError} 
        autoComplete="off" autoCorrect="none" size="small" variant="outlined" {...textProps}/>
}
